export default __webpack_public_path__ + "static/media/pantry1-afterF-1024w.4d491ed1.png";